import { BaseStore } from "~/stores/BaseStore";
import { RootStore } from "~/stores/RootStore";
import { Asset } from "../models/Asset";

export class AssetStore extends BaseStore<Asset> {
  constructor(rootStore: RootStore) {
    super(rootStore, Asset);
  }
}
